import { useEffect, useState } from "react";
import { useNavigate, useParams, Link } from "react-router-dom";
import { ArrowLeft, Save, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "../lib/api";
import { Input } from "../components/ui/input";
import { Textarea } from "../components/ui/textarea";
import { Label } from "../components/ui/label";
import { Switch } from "../components/ui/switch";
import { UploadButton } from "../components/UploadButton";
import AirportSelector from "@/components/AirportSelector";
import AirlineSelector from "@/components/AirlineSelector";
import HotelSelector from "@/components/HotelSelector";

const EMPTY = {
  id: "", name: "", fullTitle: "", subtitle: "", headline: "",
  badge: "", badgeLong: "", duration: "", durasi: "",
  tipePaket: "Umroh", departures: "",
  departureDate: "", returnDate: "", departureCity: "",
  availableSeats: 0, priceFrom: "", airline: "",
  hotelMakkah: "", hotelMadinah: "",
  image: "", gallery: [],
  overview: "", routes: [],
  bonuses: [], pembimbing: "",
  highlights: [], includes: [], excludes: [], terms: [],
  hotels: [], flights: [], transports: [], itinerary: [],
  published: true, order: 99,
};

const linesToArr = (s) => (s || "").split(/\r?\n/).map((x) => x.trim()).filter(Boolean);
const arrToLines = (a) => (a || []).join("\n");

export default function AdminPackageEditor() {
  const { id } = useParams();
  const isEdit = !!id;
  const nav = useNavigate();
  const [form, setForm] = useState(EMPTY);
  const [loading, setLoading] = useState(false);
  const [loadingItem, setLoadingItem] = useState(isEdit);
  const [airlines, setAirlines] = useState([]);
const [airports, setAirports] = useState([]);
  const [hotels, setHotels] = useState([]);
  const [itineraryTemplates, setItineraryTemplates] = useState([]);
  const [bonusTemplates, setBonusTemplates] = useState([]);
  const [transportTemplates, setTransportTemplates] = useState([]);  
  const legacyDuration = (() => {
  const days = parseInt(form.durasi || "0", 10);

  if (!days) return "";

  return `${days} ${days === 1 ? "Day" : "Days"}`;
})();

  const autoAirline =
  form.flights?.[0]?.airline || "";

const autoDepartureCity =
  form.flights?.[0]?.from?.city || "";

const autoHotelMakkah =
  form.hotels?.find(
    (h) => h.location === "Makkah"
  )?.name || "";

const autoHotelMadinah =
  form.hotels?.find(
    (h) => h.location === "Madinah"
  )?.name || "";

useEffect(() => {
    if (!isEdit) return;
    api.get(`/admin/packages/${id}`)
      .then((r) => setForm({ ...EMPTY, ...r.data }))
      .catch(() => { toast.error("Package not found"); nav("/admin/packages"); })
      .finally(() => setLoadingItem(false));
  }, [id, isEdit, nav]);
useEffect(() => {
  api.get("/admin/master/airlines")
    .then((r) => setAirlines(r.data || []))
    .catch(() => {});
}, []);

useEffect(() => {
  api.get("/master/airports")
    .then((r) => setAirports(r.data || []))
    .catch(() => {
      setAirports([]);
      toast.error("Gagal memuat data airport");
    });
}, []);

useEffect(() => {
  api.get("/master/hotels")
    .then((r) => setHotels(r.data || []))
    .catch(() => {});
}, []);

useEffect(() => {
  api.get("/master/itinerary")
    .then((r) => setItineraryTemplates(r.data || []))
    .catch(() => {});
}, []);

useEffect(() => {
  api.get("/master/bonus")
    .then((r) => setBonusTemplates(r.data || []))
    .catch(() => {});
}, []);

useEffect(() => {
  api.get("/master/transports")
    .then((r) => setTransportTemplates(r.data || []))
    .catch(() => {});
}, []);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e?.target ? e.target.value : e }));
  const setArr = (k) => (e) => setForm((f) => ({ ...f, [k]: linesToArr(e.target.value) }));
  const setItinerary = (idx, key, val) => setForm((f) => {
    const it = [...(f.itinerary || [])];
    it[idx] = { ...it[idx], [key]: val };
    return { ...f, itinerary: it };
  });
  const setItineraryActs = (idx, val) => setItinerary(idx, "activities", linesToArr(val));
  const addItineraryDay = () => setForm((f) => ({ ...f, itinerary: [...(f.itinerary || []), { day: (f.itinerary?.length || 0) + 1, date: "", dayName: "", title: "", meals: "", activities: [] }] }));
  const removeItineraryDay = (i) => setForm((f) => ({ ...f, itinerary: f.itinerary.filter((_, k) => k !== i) }));

  const setHotel = (idx, key, val) => setForm((f) => {
    const arr = [...(f.hotels || [])];
    arr[idx] = { ...arr[idx], [key]: val };
    return { ...f, hotels: arr };
  });
  const addHotel = () => setForm((f) => ({ ...f, hotels: [...(f.hotels || []), { name: "", rating: 4, location: "", description: "", checkIn: "", checkOut: "", image: "" }] }));
  const removeHotel = (i) => setForm((f) => ({ ...f, hotels: f.hotels.filter((_, k) => k !== i) }));

  const setFlight = (idx, key, val) => setForm((f) => {
    const arr = [...(f.flights || [])];
    arr[idx] = { ...arr[idx], [key]: val };
    return { ...f, flights: arr };
  });
  const setFlightSub = (idx, side, key, val) => setForm((f) => {
    const arr = [...(f.flights || [])];
    arr[idx] = { ...arr[idx], [side]: { ...(arr[idx]?.[side] || {}), [key]: val } };
    return { ...f, flights: arr };
  });
  const addFlight = () => setForm((f) => ({ ...f, flights: [...(f.flights || []), 

{
  type: "Departure",
  airline: "",
  logo: "",
  from: { code: "", name: "", city: "" },
  to: { code: "", name: "", city: "" },

  departDate: "",
  arriveDate: "",

  departTime: "",
  arriveTime: ""
}

] }));
  const removeFlight = (i) => setForm((f) => ({ ...f, flights: f.flights.filter((_, k) => k !== i) }));

  const setBonus = (idx, key, val) => setForm((f) => {
    const arr = [...(f.bonuses || [])];
    arr[idx] = { ...arr[idx], [key]: val };
    return { ...f, bonuses: arr };
  });
  const addBonus = () => setForm((f) => ({ ...f, bonuses: [...(f.bonuses || []), { title: "", desc: "", image: "" }] }));
  const removeBonus = (i) => setForm((f) => ({ ...f, bonuses: f.bonuses.filter((_, k) => k !== i) }));

  const setTransport = (idx, key, val) => setForm((f) => {
    const arr = [...(f.transports || [])];
    arr[idx] = { ...arr[idx], [key]: val };
    return { ...f, transports: arr };
  });
  const addTransport = () => setForm((f) => ({ ...f, transports: [...(f.transports || []), { name: "", logo: "" }] }));
  const removeTransport = (i) => setForm((f) => ({ ...f, transports: f.transports.filter((_, k) => k !== i) }));

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!form.name?.trim() || !form.fullTitle?.trim()) {
      toast.error("Name and Full Title are required.");
      return;
    }
    setLoading(true);
    try {
const rawCity =
  form.flights?.[0]?.from?.city ||
  form.departureCity ||
  "";

const cityMapping = {
  Singapore: "Batam",
  Singapura: "Batam",
  Batam: "Batam",
  Palembang: "Palembang",
};

const departureCity =
  cityMapping[rawCity] || rawCity;



const payload = {
  ...form,

  departureCity,

  airline:
    form.flights?.[0]?.airline ||
    form.airline ||
    "",

  hotelMakkah:
    form.hotels?.find(
      (h) => h.location === "Makkah"
    )?.name ||
    form.hotelMakkah ||
    "",

  hotelMadinah:
    form.hotels?.find(
      (h) => h.location === "Madinah"
    )?.name ||
    form.hotelMadinah ||
    "",

  duration:
    form.durasi
      ? form.durasi.replace("Hari", "Days").trim()
      : form.duration,

  availableSeats: Number(form.availableSeats) || 0,
  order: Number(form.order) || 99,
};

      if (isEdit) {
        await api.patch(`/admin/packages/${id}`, payload);
        toast.success("Package updated");
      } else {
        await api.post("/admin/packages", payload);
        toast.success("Package created");
      }
      nav("/admin/packages");
    } catch (err) {
      toast.error(formatApiErrorDetail(err?.response?.data?.detail) || "Failed to save");
    } finally {
      setLoading(false);
    }
  };

  if (loadingItem) return <div className="p-12 text-center text-muted">Loading...</div>;

  return (
    <div className="p-6 md:p-12 max-w-5xl mx-auto" data-testid="admin-pkg-editor">
      <Link to="/admin/packages" className="text-sm text-muted hover:text-accent inline-flex items-center gap-2">
        <ArrowLeft className="w-4 h-4" /> Back to packages
      </Link>
      <h1 className="font-serif-display text-primary text-4xl mt-4">{isEdit ? "Edit Package" : "New Package"}</h1>

      <form onSubmit={onSubmit} className="mt-10 space-y-10">
        <Section title="Basic Info">
          <Field label="Package ID (URL slug)"><Input data-testid="pkg-id" value={form.id} onChange={set("id")} disabled={isEdit} placeholder="auto from name" /></Field>
          <Field label="Short Name *"><Input data-testid="pkg-name" value={form.name} onChange={set("name")} placeholder="Umroh VIP" /></Field>
          <Field label="Full Title *"><Input data-testid="pkg-fulltitle" value={form.fullTitle} onChange={set("fullTitle")} placeholder="Umroh VIP Maret 2026 12 Hari [start Batam]" /></Field>
          <Field label="Subtitle"><Input value={form.subtitle} onChange={set("subtitle")} /></Field>
          <Field label="Headline (route line)"><Input value={form.headline} onChange={set("headline")} placeholder="BATAM - SINGAPORE - JEDDAH" /></Field>
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Badge (short)"><Input value={form.badge} onChange={set("badge")} placeholder="Premium" /></Field>
            <Field label="Badge (long)"><Input value={form.badgeLong} onChange={set("badgeLong")} /></Field>
          </div>
        </Section>

        <Section title="Trip Details">
          <div className="grid sm:grid-cols-2 gap-4">
            <Field label="Tipe Paket"><Input value={form.tipePaket} onChange={set("tipePaket")} /></Field>
<Field label="Durasi (display)">
  <select
    value={form.durasi || ""}
    onChange={set("durasi")}
    className="w-full rounded-xl border border-soft bg-background px-3 py-2"
  >
    <option value="">Pilih Durasi</option>

    {Array.from({ length: 25 }, (_, i) => (
      <option
        key={i + 1}
        value={`${i + 1} Hari`}
      >
        {i + 1} Hari
      </option>
    ))}
  </select>
</Field>

<Field label="Duration (legacy short)">
  <Input
    value={legacyDuration}
    readOnly
  />
</Field>

<Field label="Maskapai">
  <Input
    value={autoAirline}
    readOnly
  />
</Field>

<Field label="Departure Date">
  <Input
    type="date"
    value={form.departureDate}
    onChange={set("departureDate")}
  />
</Field>

<Field label="Return Date">
  <Input
    type="date"
    value={form.returnDate}
    onChange={set("returnDate")}
  />
</Field>

<Field label="Departure City">
  <Input
    value={autoDepartureCity}
    readOnly
  />
</Field>

            <Field label="Departures (display schedule)"><Input value={form.departures} onChange={set("departures")} placeholder="Bulanan / Mar - May 2026" /></Field>
            <Field label="Available Seats"><Input type="number" value={form.availableSeats} onChange={set("availableSeats")} /></Field>
            <Field label="Price From"><Input value={form.priceFrom} onChange={set("priceFrom")} placeholder="Rp 39,500,000" /></Field>
<Field label="Hotel Makkah">
  <Input
    value={autoHotelMakkah}
    readOnly
  />
</Field>

<Field label="Hotel Madinah">
  <Input
    value={autoHotelMadinah}
    readOnly
  />
</Field>

            <Field label="Display order"><Input type="number" value={form.order} onChange={set("order")} /></Field>
            <Field label="Pembimbing"><Input value={form.pembimbing} onChange={set("pembimbing")} /></Field>
          </div>
        </Section>

        <Section title="Images & Gallery">
          <Field label="Hero Image URL">
            <div className="flex gap-2 flex-wrap">
              <Input value={form.image} onChange={set("image")} className="flex-1 min-w-[250px]" />
              <UploadButton testid="pkg-hero-upload" label="Upload" onUploaded={(url) => setForm((f) => ({ ...f, image: url }))} />
            </div>
            {form.image && <img src={form.image} alt="" className="mt-3 w-40 h-28 object-cover rounded-lg" />}
          </Field>
          <Field label="Gallery URLs (one per line)">
            <div className="flex gap-2 flex-wrap items-start">
              <Textarea rows={5} value={arrToLines(form.gallery)} onChange={(e) => setForm((f) => ({ ...f, gallery: linesToArr(e.target.value) }))} placeholder="https://...jpg" className="flex-1 min-w-[300px]" />
              <UploadButton testid="pkg-gallery-upload" label="Upload to gallery" onUploaded={(url) => setForm((f) => ({ ...f, gallery: [...(f.gallery || []), url] }))} />
            </div>
            {(form.gallery || []).length > 0 && (
              <div className="mt-3 grid grid-cols-3 md:grid-cols-5 gap-2">
                {form.gallery.map((src, i) => (
                  <div key={i} className="relative group">
                    <img src={src} alt="" className="w-full aspect-square object-cover rounded-lg" />
                    <button
                      type="button"
                      onClick={() => setForm((f) => ({ ...f, gallery: f.gallery.filter((_, k) => k !== i) }))}
                      className="absolute top-1 right-1 w-6 h-6 grid place-items-center bg-red-600 text-white rounded-full opacity-0 group-hover:opacity-100 transition"
                    >
                      <Trash2 className="w-3 h-3" />
                    </button>
                  </div>
                ))}
              </div>
            )}
          </Field>
        </Section>

        <Section title="Overview & Routes">
          <Field label="Overview"><Textarea rows={4} value={form.overview} onChange={set("overview")} /></Field>
          <Field label="Routes (one per line)"><Textarea rows={5} value={arrToLines(form.routes)} onChange={setArr("routes")} /></Field>
        </Section>

        <Section title="Includes / Excludes / Highlights / Terms (one per line)">
          <div className="grid md:grid-cols-2 gap-4">
            <Field label="Includes"><Textarea rows={6} value={arrToLines(form.includes)} onChange={setArr("includes")} /></Field>
            <Field label="Excludes"><Textarea rows={6} value={arrToLines(form.excludes)} onChange={setArr("excludes")} /></Field>
            <Field label="Highlights"><Textarea rows={6} value={arrToLines(form.highlights)} onChange={setArr("highlights")} /></Field>
            <Field label="Terms"><Textarea rows={6} value={arrToLines(form.terms)} onChange={setArr("terms")} /></Field>
          </div>
        </Section>

        <Section title="Bonuses" onAdd={addBonus} addLabel="Add bonus">
          {(form.bonuses || []).map((b, i) => (
            <Card key={i} onRemove={() => removeBonus(i)}>

<Field label="Bonus">
  <select
    className="w-full border rounded p-2"
    value={b.title || ""}
    onChange={(e) => {

      const selected = bonusTemplates.find(
        (x) => x.title === e.target.value
      );

      const bonuses = [...(form.bonuses || [])];

      bonuses[i] = {
        ...bonuses[i],
        title: selected?.title || "",
        desc: selected?.description || "",
        image: selected?.image || "",
      };

      setForm({
        ...form,
        bonuses,
      });
    }}
  >
    <option value="">
      Select Bonus
    </option>

    {bonusTemplates.map((bonus) => (
      <option
        key={bonus.id}
        value={bonus.title}
      >
        {bonus.title}
      </option>
    ))}
  </select>
</Field>

<Field label="Description">
  <Textarea
    rows={2}
    value={b.desc || ""}
    readOnly
  />
</Field>

<Field label="Bonus Preview">
  {b.image ? (
    <img
      src={b.image}
      alt={b.title}
      className="w-full h-40 object-cover rounded border"
    />
  ) : (
    <div className="border rounded p-4 text-sm text-gray-500">
      No image
    </div>
  )}
</Field>
            </Card>
          ))}
        </Section>

        <Section title="Hotels" onAdd={addHotel} addLabel="Add hotel">
          {(form.hotels || []).map((h, i) => (
            <Card key={i} onRemove={() => removeHotel(i)}>
              <div className="grid sm:grid-cols-2 gap-3">

<Field label="Hotel">
  <HotelSelector
    hotels={hotels}
    value={h.name || ""}
    onSelect={(hotel) => {

      const arr = [...(form.hotels || [])];

      arr[i] = {
        ...arr[i],
        name: hotel.name,
        location: hotel.location_type,
        rating: hotel.rating,
        image: hotel.image,
        description: hotel.description,
      };

      setForm({
        ...form,
        hotels: arr,
      });
    }}
  />
</Field>

<Field label="Location">
  <Input
    value={h.location || ""}
    readOnly
  />
</Field>

<Field label="Rating">
  <Input
    value={h.rating || ""}
    readOnly
  />
</Field>
<Field label="Hotel Preview">
  {h.image ? (
    <img
      src={h.image}
      alt={h.name}
      className="w-full h-40 object-cover rounded border"
    />
  ) : (
    <div className="border rounded p-4 text-sm text-gray-500">
      No image
    </div>
  )}
</Field>

<Field label="Check-in">
  <Input
    type="date"
    value={h.checkIn || ""}
    onChange={(e) => setHotel(i, "checkIn", e.target.value)}
  />
</Field>

<Field label="Check-out">
  <Input
    type="date"
    value={h.checkOut || ""}
    onChange={(e) => setHotel(i, "checkOut", e.target.value)}
  />
</Field>

              </div>
<Field label="Description">
  <Textarea
    rows={2}
    value={h.description || ""}
    readOnly
  />
</Field>

            </Card>
          ))}
        </Section>


<Section title="Flights" onAdd={addFlight} addLabel="Add flight">
  {(form.flights || []).map((f, i) => (
    <Card key={i} onRemove={() => removeFlight(i)}>

      <div className="grid sm:grid-cols-3 gap-3">

        <Field label="Type">
          <select
            className="w-full border rounded p-2"
            value={f.type || "Departure"}
            onChange={(e) =>
              setFlight(i, "type", e.target.value)
            }
          >
            <option value="Departure">
              Keberangkatan
            </option>

            <option value="Arrival">
              Kepulangan
            </option>
          </select>
        </Field>

<Field label="Airline">
  <AirlineSelector
    airlines={airlines}
    value={f.airline || ""}
    onSelect={(selected) => {
      const flights = [...(form.flights || [])];

      flights[i] = {
        ...flights[i],
        airline: selected?.name || "",
        logo: selected?.logo || "",
      };

      setForm({
        ...form,
        flights,
      });
    }}
  />
</Field>

<Field label="Airline Logo">
  {f.logo ? (
    <img
      src={f.logo}
      alt={f.airline}
      className="w-full h-24 object-contain rounded border bg-white"
    />
  ) : (
    <div className="border rounded p-4 text-sm text-gray-500">
      No logo
    </div>
  )}
</Field>
      </div>

      <div className="grid sm:grid-cols-2 gap-3 mt-2">

        <Card titleAttr="From">

<Field label="Airport">
  <AirportSelector
    airports={airports}
    value={f.from?.code || ""}
    onSelect={(airport) => {
      const flights = [...(form.flights || [])];

      flights[i] = {
        ...flights[i],
        from: {
          code: airport.code,
          name: airport.name,
          city: airport.city,
          country: airport.country,
        },
      };

      setForm({
        ...form,
        flights,
      });
    }}
  />
</Field>

          <Field label="Code">
            <Input
              value={f.from?.code || ""}
              readOnly
            />
          </Field>

          <Field label="City">
            <Input
              value={f.from?.city || ""}
              readOnly
            />
          </Field>
           
           <Field label="Country">
  <Input
    value={f.from?.country || ""}
    readOnly
  />
</Field>

<Field label="Depart Date">
  <Input
    type="date"
    value={f.departDate || ""}
    onChange={(e) =>
      setFlight(i, "departDate", e.target.value)
    }
  />
</Field>

<Field label="Depart Time">
  <Input
    type="time"
    value={f.departTime || ""}
    onChange={(e) =>
      setFlight(i, "departTime", e.target.value)
    }
  />
</Field>

        </Card>

        <Card titleAttr="To">


<Field label="Airport">
  <AirportSelector
    airports={airports}
    value={f.to?.code || ""}
    onSelect={(airport) => {
      const flights = [...(form.flights || [])];

      flights[i] = {
        ...flights[i],
        to: {
          code: airport.code,
          name: airport.name,
          city: airport.city,
          country: airport.country,
        },
      };

      setForm({
        ...form,
        flights,
      });
    }}
  />
</Field>



          <Field label="Code">
            <Input
              value={f.to?.code || ""}
              readOnly
            />
          </Field>

          <Field label="City">
            <Input
              value={f.to?.city || ""}
              readOnly
            />
          </Field>
<Field label="Country">
  <Input
    value={f.to?.country || ""}
    readOnly
  />
</Field>
<Field label="Arrive Date">
  <Input
    type="date"
    value={f.arriveDate || ""}
    onChange={(e) =>
      setFlight(i, "arriveDate", e.target.value)
    }
  />
</Field>

<Field label="Arrive Time">
  <Input
    type="time"
    value={f.arriveTime || ""}
    onChange={(e) =>
      setFlight(i, "arriveTime", e.target.value)
    }
  />
</Field>

        </Card>

      </div>

    </Card>
  ))}
</Section>




        <Section title="Transports" onAdd={addTransport} addLabel="Add transport">
          {(form.transports || []).map((t, i) => (
            <Card key={i} onRemove={() => removeTransport(i)}>
              <div className="grid sm:grid-cols-2 gap-3">

<Field label="Transport">
  <select
    className="w-full border rounded p-2"
    value={t.name || ""}
    onChange={(e) => {

      const selected = transportTemplates.find(
        (x) => x.name === e.target.value
      );

      const transports = [...(form.transports || [])];

      transports[i] = {
        ...transports[i],
        name: selected?.name || "",
        logo: selected?.logo || "",
        description: selected?.description || "",
       };

      setForm({
        ...form,
        transports,
      });
    }}
  >
    <option value="">
      Select Transport
    </option>

    {transportTemplates.map((transport) => (
      <option
        key={transport.id}
        value={transport.name}
      >
        {transport.name}
      </option>
    ))}
  </select>
</Field>

<Field label="Transport Preview">
  {t.logo ? (
    <img
      src={t.logo}
      alt={t.name}
      className="w-full h-24 object-contain rounded border bg-white"
    />
  ) : (
    <div className="border rounded p-4 text-sm text-gray-500">
      No logo
    </div>
  )}
</Field>
<Field label="Description">
  <textarea
    className="w-full border rounded p-2"
    rows={4}
    value={t.description || ""}
    onChange={(e) =>
      setTransport(i, "description", e.target.value)
    }
  />
</Field>
              </div>
            </Card>
          ))}
        </Section>

        <Section title="Itinerary (Day by Day)" onAdd={addItineraryDay} addLabel="Add day">
          {(form.itinerary || []).map((d, i) => (
            <Card key={i} onRemove={() => removeItineraryDay(i)}>
              <div className="grid sm:grid-cols-4 gap-3">

<Field label="Day">
  <select
    className="w-full border rounded p-2"
    value={d.day || ""}
    onChange={(e) =>
      setItinerary(i, "day", Number(e.target.value))
    }
  >
    {Array.from({ length: 25 }, (_, n) => n + 1).map((n) => (
      <option key={n} value={n}>
        Day {n}
      </option>
    ))}
  </select>
</Field>

<Field label="Day Name">
  <select
    className="w-full border rounded p-2"
    value={d.dayName || ""}
    onChange={(e) =>
      setItinerary(i, "dayName", e.target.value)
    }
  >
    <option value="">Pilih Hari</option>
    <option value="Senin">Senin</option>
    <option value="Selasa">Selasa</option>
    <option value="Rabu">Rabu</option>
    <option value="Kamis">Kamis</option>
    <option value="Jumat">Jumat</option>
    <option value="Sabtu">Sabtu</option>
    <option value="Ahad">Ahad</option>
  </select>
</Field>

<Field label="Date">
  <Input
    type="date"
    value={d.date || ""}
    onChange={(e) =>
      setItinerary(i, "date", e.target.value)
    }
  />
</Field>

<Field label="Meals">
  <select
    className="w-full border rounded p-2"
    value={d.meals || ""}
    onChange={(e) =>
      setItinerary(i, "meals", e.target.value)
    }
  >
    <option value="">-</option>
    <option value="Breakfast">Breakfast</option>
    <option value="Lunch">Lunch</option>
    <option value="Dinner">Dinner</option>
    <option value="Breakfast + Lunch">Breakfast + Lunch</option>
    <option value="Lunch + Dinner">Lunch + Dinner</option>
    <option value="Breakfast + Dinner">Breakfast + Dinner</option>
    <option value="3x Sehari">3x Sehari</option>
    <option value="3x Sehari + Snacks">3x Sehari + Snacks</option>
  </select>
</Field>
              </div>
<Field label="Title">
  <select
    className="w-full border rounded p-2"
    value={d.title || ""}
    onChange={(e) => {

      const selected = itineraryTemplates.find(
        (x) => x.title === e.target.value
      );

      const itinerary = [...(form.itinerary || [])];

      itinerary[i] = {
        ...itinerary[i],
        title: selected?.title || "",
        activities: selected?.description
          ? [selected.description]
          : [],
      };

      setForm({
        ...form,
        itinerary,
      });
    }}
  >
    <option value="">
      Select Itinerary
    </option>

    {itineraryTemplates.map((t) => (
      <option
        key={t.id}
        value={t.title}
      >
        {t.category} - {t.title}
      </option>
    ))}
  </select>
</Field>         
              <Field label="Activities (one per line)"><Textarea rows={4} value={arrToLines(d.activities)} onChange={(e) => setItineraryActs(i, e.target.value)} /></Field>
            </Card>
          ))}
        </Section>

        <Section title="Status">
          <div className="flex items-center gap-3 bg-surface rounded-xl p-4 border border-soft">
            <Switch checked={form.published} onCheckedChange={(v) => setForm((f) => ({ ...f, published: v }))} data-testid="pkg-published-switch" />
            <div>
              <div className="text-sm text-main">Publish on website</div>
              <div className="text-xs text-muted">If off, paket disembunyikan dari public.</div>
            </div>
          </div>
        </Section>

        <div className="flex items-center gap-3 sticky bottom-6 bg-[color:var(--bg)]/90 backdrop-blur p-4 border border-soft rounded-2xl shadow-xl z-10">
          <button type="submit" disabled={loading} data-testid="pkg-save-btn" className="bg-primary text-white hover:bg-primary/90 transition rounded-full px-8 py-3 text-sm font-medium flex items-center gap-2 disabled:opacity-60">
            {loading ? "Saving..." : (<>Save Package <Save className="w-4 h-4" /></>)}
          </button>
          <Link to="/admin/packages" className="text-sm text-muted hover:text-accent">Cancel</Link>
        </div>
      </form>
    </div>
  );
}

function Section({ title, children, onAdd, addLabel }) {
  return (
    <div>
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-serif-display text-primary text-2xl">{title}</h2>
        {onAdd && (
          <button type="button" onClick={onAdd} className="text-sm border border-soft text-primary hover:bg-surface transition rounded-full px-4 py-2 flex items-center gap-1.5">
            <Plus className="w-4 h-4" /> {addLabel || "Add"}
          </button>
        )}
      </div>
      <div className="space-y-3">{children}</div>
    </div>
  );
}
function Field({ label, children }) {
  return (
    <div>
      <Label className="text-xs uppercase tracking-[0.18em] text-muted">{label}</Label>
      <div className="mt-1.5">{children}</div>
    </div>
  );
}
function Card({ children, onRemove, titleAttr }) {
  return (
    <div className="relative bg-surface border border-soft rounded-2xl p-4 space-y-3">
      {titleAttr && <div className="text-[10px] uppercase tracking-[0.22em] text-accent font-semibold">{titleAttr}</div>}
      {onRemove && (
        <button type="button" onClick={onRemove} className="absolute top-3 right-3 text-muted hover:text-red-600">
          <Trash2 className="w-4 h-4" />
        </button>
      )}
      {children}
    </div>
  );
}
